<template>
  <v-layout row wrap>
    <v-flex pl-2 xs12>
      <h3>Taxi Checklists</h3>
    </v-flex>
    <v-layout pt-2 class="search-fields" column v-on:keyup.enter="search">
      <v-text-field
          v-model="query.filter"
          :value="query.filter"
          label="Search by taxiId, registration number, plate number"
      />
      <v-flex pt-3 style="flex: 1">
        <v-btn @click="search" color="blue" dark class="text-none">
          Search
        </v-btn>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "taxi_checklist_search_box",
  props: {
    query: Object,
  },
  data: function () {
    return {
      rideTypes: null,
    };
  },
  mounted: async function () {},
  methods: {
    fromChanged: function (d) {
      this.query.after = d;
    },
    toChanged: function (d) {
      this.query.before = d;
    },
    search: function () {
      this.$emit("search");
    },
    clear: function () {
      this.$emit("clear");
    }
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

.small-label .v-label {
  font-size: 14px !important;
}
</style>
